export const commonModules = ["permisos", "ambiental", "contratos", "permits", "environmentals", "contracts"];
